import * as Yup from 'yup';

const SCHEMA1 = Yup.object().shape({
  GameJoinApplicationGameID: Yup.string().required('انتخاب بازی الزامی است'),
});

const SCHEMA2 = Yup.object().shape({
  GameJoinApplicationAmount: Yup.number().typeError('لطفا هزینه قابل پرداخت را بصورت عدد مثبت وارد کنید').positive('مقدار باید مثبت باشد'),
});

export { SCHEMA1, SCHEMA2 };
